import React from "react";
import { Box } from "@mui/material";
import useGanttDragDatePreview from "../hooks/useGanttDragDatePreview";
import { localisedDate } from "../hooks/useGanttScale";

const formatDateTime = localisedDate({
	day: "numeric",
	month: "short",
	hour: "2-digit",
	minute: "2-digit",
});

const guideLineStyles = {
	position: "absolute",
	top: 0,
	bottom: 0,
	width: 0,
	borderLeft: "1px dashed #0056b3",
	pointerEvents: "none",
	zIndex: 5,
};

// Rides beside the dragged bar on its own row, so it stays with the bar
// without covering the label of the bar above or below
const labelStyles = {
	position: "absolute",
	transform: "translateY(-50%)",
	backgroundColor: "#0056b3",
	color: "#fff",
	fontSize: "11px",
	fontWeight: 600,
	lineHeight: 1,
	padding: "4px 6px",
	borderRadius: "3px",
	whiteSpace: "nowrap",
	pointerEvents: "none",
	zIndex: 6,
};

const LABEL_GAP = 8;
const LABEL_ESTIMATED_WIDTH = 220;

// Subscribes to drag events itself so the per-mousemove state stays inside
// this leaf; lifting it to ServicesGantt re-renders the Gantt during the
// drag, which stalls the interaction
const GanttDragDatePreview = ({ ganttApi, containerRef }) => {
	const preview = useGanttDragDatePreview({ ganttApi, containerRef });

	if (!preview) return null;

	const fitsRight =
		preview.right + LABEL_GAP + LABEL_ESTIMATED_WIDTH <= preview.containerWidth;
	const sideStyles = fitsRight
		? { left: `${preview.right + LABEL_GAP}px` }
		: {
				left: `${preview.left - LABEL_GAP}px`,
				transform: "translate(-100%, -50%)",
		  };

	return (
		<>
			<Box sx={{ ...guideLineStyles, left: `${preview.left}px` }} aria-hidden />
			<Box sx={{ ...guideLineStyles, left: `${preview.right}px` }} aria-hidden />
			<Box
				sx={{
					...labelStyles,
					top: `${preview.top + preview.height / 2}px`,
					...sideStyles,
				}}
			>
				{formatDateTime(preview.start)} → {formatDateTime(preview.end)}
			</Box>
		</>
	);
};

export default GanttDragDatePreview;
